export default "__VITE_ASSET__fxcuJ2Bi__"